import { toNumber } from "lodash-es";
import { getPath } from "../../../utils";

export const getColorCode = (value) => {
  const parsedVal = toNumber(value);

  if (parsedVal < 40) return "green";
  else if (parsedVal >= 40 && parsedVal < 85) return "yellow";
  else return "red";
};

export const isEmpty = (value) => {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === "object" && value !== null) {
    return Object.keys(value).length === 0;
  }
  return value === undefined || value === null || value === "";
};

export const scrollToId = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
};

export const scrollIdIntoView = ({
  id,
  containerId,
  behavior = "smooth",
  fromTop = true,
  offset = -200,
}) => {
  const ScrollableContainer = document.getElementById(containerId || "");
  const element = document.getElementById(id || "");

  if (element && ScrollableContainer && fromTop) {
    ScrollableContainer.scrollTo({
      top: element.offsetTop + offset,
      behavior,
    });
  } else if (element && ScrollableContainer) {
    ScrollableContainer.scrollTo({
      left: element.offsetLeft + offset,
      behavior,
    });
  }
};

export const evaluatePerms = (reqPerms = [], allMenuActions) => {
  let reqPermsEval = true;

  if (getPath(reqPerms, "length", -1) > 0) {
    reqPermsEval = reqPerms.reduce(
      (accumulator, curVal) =>
        accumulator && getPath(allMenuActions, curVal, false),
      true
    );
  }

  return reqPermsEval;
};
